import React from "react";
import PropTypes from "prop-types";
import { Icons } from "@learningblocks/exp-constants";
import className from "./style.module.scss";

const { IncorrectRelative: CloseIcon } = Icons;

export function CloseButton(props) {
  return (
    <span
      className={className.closeButton}
      onClick={props.closeToast}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          props.closeToast();
        }
      }}
      role="button"
      tabIndex="0"
    >
      <CloseIcon />
    </span>
  );
}

CloseButton.propTypes = {
  /**
   * closeToast [ injected by library]
   */
  closeToast: PropTypes.func,
};

CloseButton.defaultProps = {};
